import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Atleta } from '../services/ligaService';
import Load from './Load';

export type LeagueAthletesListTitulo = 'jogadores' | 'seguidores';

interface LeagueAthletesListProps {
  atletas: Atleta[];
  loading: boolean;
  error: string | null;
  titulo: LeagueAthletesListTitulo;
}

const TITULO_MAP: Record<LeagueAthletesListTitulo, string> = {
  jogadores: 'Jogadores da Liga',
  seguidores: 'Seguidores da Liga',
};

const VAZIO_MAP: Record<LeagueAthletesListTitulo, string> = {
  jogadores: 'Nenhum jogador encontrado.',
  seguidores: 'Nenhum seguidor encontrado.',
};

const LeagueAthletesList: React.FC<LeagueAthletesListProps> = ({
  atletas,
  loading,
  error,
  titulo,
}) => {
  const navigate = useNavigate();

  if (loading) {
    return <Load />;
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        {error}
      </div>
    );
  }

  const tituloTexto = TITULO_MAP[titulo];
  const vazioTexto = VAZIO_MAP[titulo];

  if (atletas.length === 0) {
    return (
      <div>
        <h5 className="fw-600 text-grey-900 mb-3">{tituloTexto}</h5>
        <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3">
          <div className="card-body text-center">
            <p className="mb-0">{vazioTexto}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h5 className="fw-600 text-grey-900 mb-3">{tituloTexto}</h5>
      <div className="row g-3">
        {atletas.map((atleta) => (
          <div key={atleta.id} className="col-12 col-sm-6 col-lg-4">
            <div
              className="card w-100 shadow-xss rounded-xxl border-0 p-3 hover-card"
              style={{ cursor: 'pointer' }}
              role="button"
              tabIndex={0}
              onClick={() => navigate(`/userpage/${atleta.id}`)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  navigate(`/userpage/${atleta.id}`);
                }
              }}
            >
              <div className="d-flex align-items-center">
                <figure className="avatar me-3 mb-0">
                  <img
                    src={atleta.usuario?.imagemUrl || '/assets/images/avatar.jpg'}
                    alt={atleta.usuario?.nome || 'Avatar'}
                    className="rounded-circle w-100"
                    style={{ width: 48, height: 48, objectFit: 'cover' }}
                  />
                </figure>
                <div className="flex-grow-1 min-w-0">
                  <div className="fw-600 text-grey-900 text-truncate">
                    {atleta.usuario?.nome || '—'}
                  </div>
                  {atleta.usuario?.username && (
                    <div className="font-xssss text-primary text-truncate">
                      @{atleta.usuario.username}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LeagueAthletesList;
